import request from "@/utils/request";

/**
 * 帖子评论相关 API（/api/post/comment）
 */

/**
 * 获取帖子的评论列表
 * @param {number} postId 帖子ID
 * @returns {Promise}
 */
export function getPostComments(postId) {
  return request.get(`/api/post/comment/list/${postId}`);
}

/**
 * 创建评论
 * @param {number} postId 帖子ID
 * @param {string} content 评论内容
 * @param {number} parentId 父评论ID（可选，回复时使用）
 * @returns {Promise}
 */
export function publishComment(postId, content, parentId) {
  return request.post("/api/post/comment/publish", {
    postId,
    content,
    parentId: parentId || null,
  });
}

/**
 * 删除我发出的帖子评论
 * @param {number} commentId 评论ID
 * @returns {Promise}
 */
export function deleteComment(commentId) {
  return request.delete(`/api/post/comment/${commentId}`);
}

/**
 * 获取发出的帖子评论（当前用户评论了别人的帖子）
 * @param {number} pageNum 页码
 * @param {number} pageSize 每页数量
 * @returns {Promise}
 */
export function getSentComments(pageNum = 1, pageSize = 10) {
  return request.get("/api/post/comment/sent", {
    params: { pageNum, pageSize },
  });
}

/**
 * 获取收到的帖子评论（别人评论了我的帖子）
 * @param {number} pageNum 页码
 * @param {number} pageSize 每页数量
 * @returns {Promise}
 */
export function getReceivedComments(pageNum = 1, pageSize = 10) {
  return request.get("/api/post/comment/received", {
    params: { pageNum, pageSize },
  });
}
